<script setup lang="ts">
import SignUpForm from '@signUp/components/SignUpForm.vue'
import SignUpBanner from '@signUp/components/SignUpBanner.vue'
import SignUpFooter from '@signUp/components/SignUpFooter.vue'
</script>

<template>
    <div class="bg-[#fcf9f0] w-full pb-10 pt-5">
        <div class="container mx-auto">
            <div class="flex flex-row min-h-[45vw]">
                <div class="flex w-full md:w-[50%] items-center">
                    <SignUpForm />
                </div>
                <div class="hidden md:flex w-[50%] items-center">
                    <SignUpBanner />
                </div>
            </div>
        </div>
    </div>
    <SignUpFooter />
</template>

<style>
body {
    background-color: #161d1e;
    color: #161d1e;
    font-family: Riposte-Regular, Arial, Helvetica, serif;
    letter-spacing: 0;
}
</style>
